/* FurStra: cart shows only the "was" line total (compare-at x qty) and the final price,
   plus a SAVE % badge and an Original price / Discount breakdown that adds up to the total */
(function () {
  var MAP = window.FURSTRA_COMPARE || {};

  function fmt(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function cents(el) {
    if (!el) return null;
    var n = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function hide(el) {
    if (el && el.style.display !== 'none') el.style.display = 'none';
  }

  // Show the AOV.ai bundle code as a friendly label (the real code still applies)
  function relabel(root) {
    if (!root) return;
    root.querySelectorAll('.discounts__discount').forEach(function (d) {
      d.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /AOVAI_/i.test(n.nodeValue)) n.nodeValue = ' 2-Pack Bundle Deal';
      });
    });
  }

  function process(itemsRoot, footerRoot) {
    if (!itemsRoot) return;
    relabel(itemsRoot);
    relabel(footerRoot);
    var was = 0;

    itemsRoot.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('input[data-quantity-variant-id]');
      if (!input) return;
      var data = MAP[input.getAttribute('data-quantity-variant-id')];
      var qty = parseInt(input.getAttribute('value') || input.value, 10) || 0;
      if (!data) return;
      if (!(data.c > data.p)) {
        was += data.p * qty;
        return;
      }

      var wasLine = data.c * qty;
      was += wasLine;

      // Hide the per-unit prices under the product name ($89.95 / $74.98)
      var name = row.querySelector('.cart-item__name');
      var unit = name && name.nextElementSibling;
      if (
        unit &&
        (unit.classList.contains('cart-item__discounted-prices') || unit.classList.contains('product-option'))
      ) {
        hide(unit);
      } else {
        unit = null;
      }

      // Line total: show only the "was" total struck through, then the final price
      var txt = fmt(wasLine);
      var nowLine = null;
      row.querySelectorAll('.cart-item__price-wrapper').forEach(function (line) {
        line.querySelectorAll('.cart-item__old-price').forEach(hide);
        var s = line.querySelector('.fs-was-line');
        if (!s) {
          line.insertAdjacentHTML('afterbegin', '<s class="fs-was-line">' + txt + '</s>');
        } else if (s.textContent !== txt) {
          s.textContent = txt;
        }
        if (nowLine === null) nowLine = cents(line.querySelector('dd.price, span.price'));
      });
      if (nowLine === null) nowLine = data.p * qty;

      // SAVE % badge based on what they actually pay
      var anchor = unit || name;
      if (anchor) {
        var badgeTxt = 'SAVE ' + Math.round((1 - nowLine / wasLine) * 100) + '%';
        var b = row.querySelector('.fs-badge');
        if (!b) {
          anchor.insertAdjacentHTML('afterend', '<div class="fs-badge">' + badgeTxt + '</div>');
        } else if (b.textContent !== badgeTxt) {
          b.textContent = badgeTxt;
        }
      }
    });

    if (!footerRoot) return;
    var totals = footerRoot.querySelector('.totals');
    if (!totals) return;
    var box = footerRoot.querySelector('.fs-savings');
    var now = cents(totals.querySelector('.totals__total-value'));
    var saving = now === null ? 0 : was - now;

    if (saving <= 0) {
      if (box) box.remove();
      return;
    }

    var pctAll = Math.round((saving / was) * 100);
    var html =
      '<div class="fs-row"><span>Original price</span><span><s>' + fmt(was) + '</s></span></div>' +
      '<div class="fs-row fs-row--save"><span>🏷️ Discount (' + pctAll + '% off)</span><span>-' + fmt(saving) + '</span></div>';

    var key = was + '|' + saving;
    if (!box) {
      totals.insertAdjacentHTML('beforebegin', '<div class="fs-savings" data-k="' + key + '">' + html + '</div>');
    } else if (box.getAttribute('data-k') !== key) {
      box.setAttribute('data-k', key);
      box.innerHTML = html;
    }
  }

  // Afterpay "4 payments" line under the bundle widget, following the selected tier
  function afterpay() {
    var group = [].slice.call(document.querySelectorAll('[role="radiogroup"]')).filter(function (g) {
      return g.offsetParent !== null;
    })[0];
    if (!group) return;
    var sel = group.querySelector('[role="radio"][aria-checked="true"]') || group.querySelector('[role="radio"]');
    if (!sel) return;
    var m = (sel.textContent || '').match(/now\s*A?\$\s*([\d,]+\.\d{2})/i);
    if (!m) return;
    var total = Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);
    var inst = '$' + (Math.round(total / 4) / 100).toFixed(2);
    var box = document.getElementById('fs-afterpay');
    var html =
      'or 4 interest-free payments of <strong>' + inst + '</strong> with ' +
      '<span style="display:inline-block;background:#B2FCE4;color:#000;font-weight:700;border-radius:999px;padding:1px 10px;margin-left:2px;letter-spacing:-.01em">afterpay</span>';
    if (!box) {
      var anchor = group.closest('.Avada-Bundle-Volume__Container') || group;
      anchor.insertAdjacentHTML(
        'afterend',
        '<div id="fs-afterpay" data-i="' + inst + '" style="margin:10px 0 4px;font-size:14px;line-height:1.5;color:#333">' + html + '</div>'
      );
    } else if (box.getAttribute('data-i') !== inst) {
      box.setAttribute('data-i', inst);
      box.innerHTML = html;
    }
  }

  var queued = false;
  function run() {
    queued = false;
    afterpay();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) process(drawer.querySelector('cart-drawer-items'), drawer.querySelector('.drawer__footer'));
    var page = document.getElementById('main-cart-items');
    if (page) process(page, document.getElementById('main-cart-footer'));
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function () {
      setTimeout(afterpay, 60);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
